export default "__VITE_ASSET__ca9eb8ce__"